import React, {Component, Fragment} from "react";
import {Helmet} from "react-helmet";
import SearchIcon from "../../assets/icons/search.svg";
import RefreshIcon from "../../assets/icons/refresh.svg";
import PlusIcon from "../../assets/icons/plus-white.svg";
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table';
import {Empty, Spin, Tooltip} from "antd";
import { clear_auth, set_auth } from "../../reducers/Auth";
import { connect } from "react-redux";
import { PERMISSIONS } from "../../helper/permissionHelper";
import { withPageAccess } from "../common/ProtectedPage";
import Swal from "sweetalert2";
import {Modal, ModalHeader, ModalBody, ModalFooter, Row, Col} from "reactstrap";
// import {Checkbox, Modal, Select} from "antd";
import SaveIcon from "../../assets/icons/save.svg";
import {pageNumber} from "../../functions/functionGeneral";
import Select from "react-select";
import Paging from "../paging";
import {BACKEND_API_HOST, IMG_HOST} from "../../helper/host";
import moment from "moment";
import ReactPaginate from "react-paginate";
import ArrowRight from '../../assets/icons/arrow-right.svg'
import ArrowLeft from '../../assets/icons/arrow-left.svg'
import MoreIcon from "../../assets/icons/more.svg";
import {TourContext} from "../guideComponent/guideTourProvicer";
import {withTourGuide} from "../guideComponent/withTourGuide";

export class ListInventaris extends Component {
    static contextType = TourContext;
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            datas: [],
            dataDetail: [],
            dataKaryawan: [],
            dataHistory: [],
            loading: true,
            prosesSimpan: false,
            modalAdd: false,
            modalEdit: false,
            modalPinjam: false,
            modalReturn: false,
            modalHistory: false,
            modalImport: false,
            karyawan_loading: false,
            inventaris_loading: false,
            history_loading: false,
            importLoading: false,

            filter_nama: '',
            inventaris_name: '',
            inventaris_desc: '',
            namaDetail: '',
            descDetail: '',
            idDel: '',
            idDetail: '',
            namaEdit: '',
            deskripsiEdit: '',
            namaKaryawan: '',
            tanggalPinjam: '',
            nama_karyawan: '',
            nama_inventaris: '',
            tanggalReturn: '',

            currentPage: 0,
            currentPageHistory: 0,
            totalData: 0,
            perPage: 0,
            perPageHistory: 0,
            pageCount: 0,
            paging: 10,
            karyawan_id: 0,
            id_inventaris: 0,
            idKembali: 0,
            idHistory: 0,

            inventaris_selected: null,
            karyawan_selected: null,
            importFile: null,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.handlePageHistory = this.handlePageHistory.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
        this.wantDelete = this.wantDelete.bind(this);
        this.exportInventaris = this.exportInventaris.bind(this);
        this.exportData = this.exportData.bind(this);
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this);
    }

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        if (typeof showGuide !== 'function') return;
        showGuide(target, config);
    };

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            currentPage: 0,
            [name]: value
        })
    }

    handlePageClick(data) {
        let selected = data.selected;
        this.setState({ currentPage: selected, loading: true }, () => {
            this.loadData();
        });
    }

    handlePageHistory(dataHistory) {
        let selected = dataHistory.selected;
        this.setState({ currentPageHistory: selected, dataHistory: [], history_loading: true }, () => {
            this.loadHistory();
        });
    }

    resetFilter() {
        this.setState({
            filter_nama: '',
            data: [],
            loading: true,
        }, () => this.loadData())
    }

    exportInventaris = () => {
        var AuthKey = localStorage.getItem('Presensi-Auth-Key')
        window.open(BACKEND_API_HOST + 'inventaris/export_template?token=' + AuthKey, "_blank")
    }

    exportData = () => {
        var AuthKey = localStorage.getItem('Presensi-Auth-Key')
        window.open(BACKEND_API_HOST + 'inventaris/export?token=' + AuthKey, "_blank")
    }

    addInventaris = () => {
        this.setState({
            prosesSimpan: true,
        })
        let form = {
            inventaris_name: this.state.inventaris_name,
            inventaris_desc: this.state.inventaris_desc,
        }
        this.props.request('inventaris/add', form, 'POST')
            .then(response => {
                if (response && response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 800,
                    })
                } else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        showConfirmButton: 'OK',
                    })
                }
                this.setState({
                    prosesSimpan: false,
                    modalAdd: false,
                    inventaris_name: '', inventaris_desc: '',
                }, () => this.loadData());
            })
    }

    loadData() {
        let form = {
            filter_nama: this.state.filter_nama,
            paginate: 10,
            page: this.state.currentPage + 1,
        }
        this.props.request("inventaris/list", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        data: response.data.data,
                        totalData: response.data.total,
                        pageCount: response.data.last_page,
                        perPage: response.data.per_page,
                        loading: false
                    })
                }
                this.setState({
                    loading: false
                })
            })
    }

    wantDelete() {
        Swal.fire({
            title: 'Pemberitahuan!',
            text: 'Anda yakin ingin menghapus inventaris?',
            icon: 'warning',
            confirmButtonText: 'Ya',
            showCancelButton: true,
            cancelButtonText: 'Batal',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    let form = {
                        id: this.state.idDel
                    }
                    this.setState({
                        data: [],
                        loading: true
                    })
                    this.props.request("inventaris/delete", form, 'POST')
                        .then(response => {
                            if (response && response.success) {
                                Swal.fire({
                                    title: 'Berhasil!',
                                    text: response.message,
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 800,
                                })
                                this.loadData()
                            }
                        });
                }
            })
    }

    loadDetail() {
        let form = {
            id_inventaris: this.state.idDetail
        }
        this.props.request("inventaris/detail", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        dataDetail: response.data,
                        namaEdit: response.data.inventaris_name,
                        deskripsiEdit: response.data.inventaris_desc,
                        modalEdit: true
                    })
                }
            });
    }

    editInventaris = () => {
        this.setState({
            prosesSimpan: true,
        })

        let form = {
            id: this.state.idDetail,
            nama: this.state.namaEdit,
            deskripsi: this.state.deskripsiEdit,
        }
        this.props.request("inventaris/edit", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 800,
                    })
                } else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    prosesSimpan: false,
                    modalEdit: false,
                    nama: '',
                    deskripsi: '',
                }, () => this.loadData())
            });
    }

    loadKaryawan() {
        let form = {}
        this.props.request("inventaris/list_karyawan", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        dataKaryawan: response.data,
                        loading: false
                    })
                }
            })
    }

    tambahPeminjaman = () => {
        let form = {
            karyawan_id: this.state.karyawan_id,
            inventaris_id: this.state.id_inventaris,
            tanggal_peminjaman: this.state.tanggalPinjam
        }
        this.props.request("inventaris/add-borrowing", form, 'POST')
        .then(response => {
            if (response && response.success) {
                Swal.fire({
                    title: 'Berhasil!',
                    text: response.message,
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 800,
                })
            } else if (response) {
                Swal.fire({
                    title: 'Gagal!',
                    text: response.message,
                    icon: 'warning',
                    confirmButtonText: 'OK'
                })
            }
            this.setState({
                modalPinjam: false,
                karyawan_id: '', nama_karyawan: '', nama_inventaris: '', karyawan_selected: null,
                inventaris_selected: null
            }, () => this.loadData())
        })
    }

    selesaikanPeminjaman = () => {
        let form = {
            inventaris_id: this.state.idKembali,
            tanggal_pengembalian: this.state.tanggalReturn
        }
        this.props.request("inventaris/selesaikan", form, 'POST')
        .then(response => {
            if (response && response.success) {
                Swal.fire({
                    title: 'Berhasil!',
                    text: response.message,
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 800,
                })
            } else if (response) {
                Swal.fire({
                    title: 'Gagal!',
                    text: response.message,
                    icon: 'warning',
                    confirmButtonText: 'OK'
                })
            }
            this.setState({
                modalReturn: false, tanggalReturn: '',
            }, () => this.loadData())
        })
    }

    loadHistory(id) {
        this.setState({
            dataHistory: [], history_loading: true
        }, () => {
            let form = {
                inventaris_id: this.state.idHistory,
                paginate: 2,
                page: this.state.currentPageHistory + 1,
            }
            this.props.request("inventaris/history", form, 'POST')
                .then(response => {
                    this.setState({
                        history_loading: false
                    })
                    if (response && response.success) {
                        this.setState({
                            dataHistory: response.data.data,
                            pageCountHistory: response.data.last_page,
                            totalDataHistory: response.data.total,
                            totalPerpageHistory: response.data.to,
                            perPageHistory: response.data.per_page,
                        })
                    }
                    else {
                        this.setState({
                            history_loading: false,
                        });
                    }
                })
        })
    }

    importExcel = () => {
        this.setState({
            importLoading: true
        })

        var AuthKey = localStorage.getItem('Presensi-Auth-Key')

        let formData = new FormData()
        formData.append('file', this.state.importFile)
        formData.append('token', AuthKey)

        fetch(BACKEND_API_HOST + 'inventaris/import', {
            method: 'POST',
            headers: {
                'Authorization': 'bearer ' + AuthKey
            },
            body: formData
        })
            .then((response) => response.json())
            .catch((error) => {
                console.error(error);
            })
            .then((response) => {
                if (response && response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 800,
                    })
                    window.location.reload();
                    this.setState({
                        modalimport: false,
                        loading: true,
                        importFile: null,
                        data: [],
                    }, () => {
                        this.loadData()
                    })
                }
                else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        showConfirmButton: false,
                        timer: 1200,
                    })
                    this.setState({
                        modalimport: false,
                    })
                }

                this.setState({ importLoading: false })
            })
    }

    componentDidMount() {
        this.loadData()
        this.loadKaryawan()
        this.loadHistory()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.loading === true && this.state.loading === false) {
            this.tourTimeout = setTimeout(() => {
                const tourSteps = [
                    {
                        selector: '.pengumuman-filter-nama-input',
                        title: 'Cari Inventaris',
                        content: 'Gunakan kolom pencarian ini untuk menemukan data inventaris berdasarkan nama inventaris.'
                    },
                    {
                        selector: '.pengumuman-button-refresh',
                        title: 'Muat Ulang Data',
                        content: 'Klik tombol ini untuk mereset filter pencarian dan memuat ulang daftar inventaris.'
                    }
                ];

                if (this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("C") >= 0) {
                    tourSteps.push({
                        selector: '.pengumuman-add-button',
                        title: 'Tambah Inventaris',
                        content: 'Klik tombol ini untuk menambahkan data inventaris baru ke dalam sistem.'
                    });
                }

                tourSteps.push({
                    selector: '.btn.border.border-dark.border-1',
                    title: 'Menu Aksi Tambahan',
                    content: 'Gunakan tombol ini untuk membuka menu aksi tambahan seperti membuat peminjaman, import data, atau export data inventaris.'
                });

                if (!this.state.loading && this.state.data.length === 0) {
                    tourSteps.push({
                        selector: '.daftar-pengumuman',
                        title: 'Daftar Inventaris (Kosong)',
                        content: 'Belum ada data inventaris yang tersedia. Gunakan tombol "Tambah Inventaris" untuk menambahkan data baru.'
                    });
                } else {
                    tourSteps.push(
                        {
                            selector: '.table',
                            title: 'Daftar Inventaris',
                            content: `Tabel ini menampilkan ${this.state.data.length} data inventaris yang tersedia di sistem.`
                        },
                        {
                            selector: '.fa-ellipsis-v',
                            title: 'Aksi',
                            content: 'Klik ikon ini untuk membuka menu aksi pada data inventaris, seperti melihat riwayat peminjaman, menyelesaikan peminjaman, edit, atau hapus data inventaris.'
                        }
                    );
                }

                const { setSteps, setCurrent, setActive } = this.context;
                setSteps(tourSteps);
                setCurrent(0);
                setActive(true);
            }, 500);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.tourTimeout);
    }

    render() {
        let no = 0
        const stylefoto = {
            height: '50px',
            width: '50px',
            objectFit: 'cover'
        }
        return (
                <Fragment>
                    <Helmet>
                        <meta charSet="utf-8"/>
                        <title>Daftar Inventaris - Presensi</title>
                        <meta name="description" content="Daftar Inventaris"/>
                    </Helmet>

                    {/*Tambah Inventaris*/}
                    <Modal size="lg" zIndex={999} isOpen={this.state.modalAdd} toggle={() => this.setState({
                        modalAdd: false, inventaris_name: '', inventaris_desc: '',
                    })} style={{ maxWidth: "1000px"}}>
                        <ModalHeader toggle={() => {
                            this.setState({
                                modalAdd: false, inventaris_name: '', inventaris_desc: ''
                            })
                        }} className="pengumuman-modal-header">
                            <div className="pengumuman-modal-header-font">Tambah Inventaris</div>
                        </ModalHeader>
                        <ModalBody className="pengumuman-modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="mb-2 pengumuman-label-input">Nama Inventaris</label>
                                        <div>
                                            <input name="inventaris_name" className="form-control pengumuman-input"
                                                   placeholder="Ketikan nama inventaris disini"
                                                   type="text" required="" onChange={this.handleChange}
                                                   onPointerEnter={(e) => {
                                                       this.triggerGuideOnce(e, {
                                                           key: "namaInventarisAdd",
                                                           title: "Nama Inventaris",
                                                           content: "Masukkan nama inventaris yang akan didaftarkan ke dalam sistem."
                                                       });
                                                   }}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="mb-2 pengumuman-label-input">Deskripsi Inventaris</label>
                                        <div>
                                            <input name="inventaris_desc" className="form-control pengumuman-input"
                                                   placeholder="Ketik deksripsi singkat disini"
                                                   type="text" required="" onChange={this.handleChange}
                                                   onPointerEnter={(e) => {
                                                       this.triggerGuideOnce(e, {
                                                           key: "deskripsiInventarisAdd",
                                                           title: "Deskripsi Inventaris",
                                                           content: "Masukkan deskripsi atau keterangan tambahan mengenai inventaris agar lebih mudah dikenali."
                                                       });
                                                   }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter className="pengumuman-modal-footer">
                            <button onClick={() => this.setState({
                                modalAdd: false, inventaris_name: '', inventaris_desc: '',
                            })} className='pengumuman-cancel-button'>Batalkan
                            </button>
                            <button className='pengumuman-save-button' disabled={this.state.prosesSimpan}
                                    onClick={this.addInventaris}><img alt=''
                                                                      src={SaveIcon}/> {this.state.prosesSimpan ? "Menyimpan.." : "Simpan"}
                            </button>
                        </ModalFooter>
                    </Modal>

                    {/*Edit*/}
                    <Modal size="lg" zIndex={999} isOpen={this.state.modalEdit} toggle={() => this.setState({
                        modalEdit: false, namaEdit: '', deskripsiEdit: '',
                    })} style={{ maxWidth: "1000px"}}>
                        <ModalHeader toggle={() => {
                            this.setState({
                                modalEdit: false, namaEdit: '', deskripsiEdit: '',
                            })
                        }} className="pengumuman-modal-header">
                            <div className="pengumuman-modal-header-font">Edit Inventaris</div>
                        </ModalHeader>
                        <ModalBody className="pengumuman-modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="mb-2 pengumuman-label-input">Nama Inventaris</label>
                                        <div>
                                            <input name="namaEdit" className="form-control pengumuman-input"
                                                   placeholder="Ketikan nama inventaris disini"
                                                   type="text" required="" onChange={this.handleChange} value={this.state.namaEdit}
                                                   onPointerEnter={(e) => {
                                                       this.triggerGuideOnce(e, {
                                                           key: "namaInventarisEdit",
                                                           title: "Nama Inventaris",
                                                           content: "Masukkan nama inventaris yang akan didaftarkan ke dalam sistem."
                                                       });
                                                   }}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="mb-2 pengumuman-label-input">Deskripsi Inventaris</label>
                                        <div>
                                            <input name="deskripsiEdit" className="form-control pengumuman-input"
                                                   placeholder="Ketik deksripsi singkat disini"
                                                   type="text" required="" onChange={this.handleChange} value={this.state.deskripsiEdit}
                                                   onPointerEnter={(e) => {
                                                       this.triggerGuideOnce(e, {
                                                           key: "deskripsiInventarisEdit",
                                                           title: "Deskripsi Inventaris",
                                                           content: "Masukkan deskripsi atau keterangan tambahan mengenai inventaris agar lebih mudah dikenali."
                                                       });
                                                   }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter className="pengumuman-modal-footer">
                            <button onClick={() => this.setState({
                                modalEdit: false, namaEdit: '', deskripsiEdit: '',
                            })} className='pengumuman-cancel-button'>Batalkan
                            </button>
                            <button className='pengumuman-save-button' onClick={this.editInventaris}><img alt='' src={SaveIcon}/> Simpan
                            </button>
                        </ModalFooter>
                    </Modal>

                    {/*Peminjaman*/}
                    <Modal size="lg" zIndex={999} isOpen={this.state.modalPinjam} toggle={() => this.setState({
                        modalPinjam: false, namaKaryawan: '', tanggalPinjam: '', karyawan_selected: null,
                    })} style={{ maxWidth: "1000px"}}>
                        <ModalHeader toggle={() => {
                            this.setState({
                                modalPinjam: false, namaKaryawan: '', tanggalPinjam: '',karyawan_selected: null,
                            })
                        }} className="pengumuman-modal-header">
                            <div className="pengumuman-modal-header-font">Tambah Peminjaman</div>
                        </ModalHeader>
                        <ModalBody className="pengumuman-modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="mb-2 pengumuman-label-input">Nama Karyawan</label>
                                        <div>
                                            <Select
                                                placeholder="Nama Karyawan"
                                                backspaceRemoves={true} deleteRemoves={true}
                                                styles={{paddingLeft: "0px", fontSize: '12px'}}
                                                components={{
                                                    DropdownIndicator: () => null,
                                                    IndicatorSeparator: () => null
                                                }}
                                                value={this.state.karyawan_selected}
                                                isLoading={this.state.karyawan_loading}
                                                options={
                                                    this.state.dataKaryawan != null ? (
                                                            this.state.dataKaryawan.map((item, index) => (
                                                                {
                                                                    key: index,
                                                                    value: item.karyawan_id,
                                                                    label: item.karyawan_nama,
                                                                }
                                                            ))
                                                        )
                                                        : (" ")
                                                }
                                                onChange={
                                                    (karyawan_selected) => {
                                                        if (!karyawan_selected) {
                                                            this.setState({
                                                                karyawan_selected: '',
                                                                karyawan_id: 0,
                                                            })
                                                        } else {
                                                            this.setState({
                                                                karyawan_selected,
                                                                karyawan_id: karyawan_selected.value,
                                                                nama_karyawan: karyawan_selected.label
                                                            })
                                                        }
                                                    }
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="mb-2 pengumuman-label-input">Nama Inventaris</label>
                                        <div>
                                            <Select
                                                placeholder="Nama Inventaris"
                                                backspaceRemoves={true} deleteRemoves={true}
                                                styles={{paddingLeft: "0px", fontSize: '12px'}}
                                                components={{
                                                    DropdownIndicator: () => null,
                                                    IndicatorSeparator: () => null
                                                }}
                                                value={this.state.inventaris_selected}
                                                isLoading={this.state.inventaris_loading}
                                                options={
                                                    this.state.data != null ? (
                                                            this.state.data.map((item, index) => (
                                                                {
                                                                    key: index,
                                                                    value: item.inventaris_id,
                                                                    label: item.inventaris_name,
                                                                }
                                                            ))
                                                        )
                                                        : (" ")
                                                }
                                                onChange={
                                                    (inventaris_selected) => {
                                                        if (!inventaris_selected) {
                                                            this.setState({
                                                                inventaris_selected: '',
                                                                inventaris_id: 0,
                                                            })
                                                        } else {
                                                            this.setState({
                                                                inventaris_selected,
                                                                id_inventaris: inventaris_selected.value,
                                                                nama_inventaris: inventaris_selected.label
                                                            })
                                                        }
                                                    }
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="mb-2 pengumuman-label-input">Tanggal Peminjaman</label>
                                        <div>
                                            <input name="tanggalPinjam" className="form-control pengumuman-input"
                                                   placeholder="Ketik deksripsi singkat disini"
                                                   type="date" required="" onChange={this.handleChange}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter className="pengumuman-modal-footer">
                            <button onClick={() => this.setState({
                                modalPinjam: false, namaKaryawan: '', tanggalPinjam: '', karyawan_selected: null,
                            })} className='pengumuman-cancel-button'>Batalkan
                            </button>
                            <button className='pengumuman-save-button' onClick={this.tambahPeminjaman}><img alt='' src={SaveIcon}/> Simpan
                            </button>
                        </ModalFooter>
                    </Modal>

                    {/*Return Peminjaman*/}
                    <Modal size="lg" zIndex={999} isOpen={this.state.modalReturn} toggle={() => this.setState({
                        modalReturn: false, tanggalReturn: '',
                    })} style={{ maxWidth: "1000px"}}>
                        <ModalHeader toggle={() => {
                            this.setState({
                                modalReturn: false, tanggalReturn: '',
                            })
                        }} className="pengumuman-modal-header">
                            <div className="pengumuman-modal-header-font">Selesaikan Peminjaman</div>
                        </ModalHeader>
                        <ModalBody className="pengumuman-modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="mb-2 pengumuman-label-input">Tanggal Pengembalian</label>
                                        <div>
                                            <input name="tanggalReturn" className="form-control pengumuman-input"
                                                   type="date" required="" onChange={this.handleChange}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter className="pengumuman-modal-footer">
                            <button onClick={() => this.setState({
                                modalReturn: false, tanggalReturn: '',
                            })} className='pengumuman-cancel-button'>Batalkan
                            </button>
                            <button className='pengumuman-save-button' onClick={this.selesaikanPeminjaman}><img alt='' src={SaveIcon}/> Simpan
                            </button>
                        </ModalFooter>
                    </Modal>

                    {/*History*/}
                    <Modal size="lg" zIndex={999} isOpen={this.state.modalHistory} toggle={() => this.setState({
                        modalHistory: false, dataHistory:[], idHistory: 0,
                    })} style={{ maxWidth: "1000px"}}>
                        <ModalHeader toggle={() => {
                            this.setState({
                                modalHistory: false, dataHistory:[], idHistory: 0,
                            })
                        }} className="pengumuman-modal-header">
                            <div className="pengumuman-modal-header-font">Riwayat Peminjaman</div>
                        </ModalHeader>
                        <ModalBody className="pengumuman-modal-body">
                            <div className="list-group">
                                <div>
                                    {this.state.history_loading && (
                                        <div style={{textAlign: "center", margin: '10px auto'}}>
                                            <Spin size="large" tip="Loading..."
                                                  style={{width: "100%", margin: "auto"}}/>
                                        </div>
                                    )}
                                    {this.state.dataHistory.length !== 0 && (
                                        <div>
                                            <Row>
                                                <Col xs={0} md={0} className="text-left" style={{ marginLeft: '20px' }}>
                                                    <h4>Karyawan</h4>
                                                </Col>
                                                <Col xs={0} md={0} className="text-left"style={{ marginRight: '20px' }}>
                                                    <h4>Aktivitas</h4>
                                                </Col>
                                            </Row>

                                            {this.state.dataHistory.map((item, index) => {
                                                return (
                                                    <div key={index}>
                                                        <Row>
                                                            <Col xs={12} md={6} className="text-left">
                                                                <div style={{ display: 'flex', alignItems: 'center', paddingTop: '16px',paddingBottom:'16px', paddingRight:'12px', paddingLeft:'12px' }}>
                                                                    <div style={{marginRight: '16px'}}>
                                                                        {item.karyawan.karyawan_foto !== null ? (
                                                                            <img
                                                                                src={IMG_HOST + 'frontapp/karyawan/' + item.karyawan.karyawan_foto}
                                                                                alt=""
                                                                                style={stylefoto}
                                                                            />
                                                                        ) : (<img
                                                                            src={IMG_HOST + "user-profile.png"}
                                                                            alt=""
                                                                            style={stylefoto}
                                                                        />)}
                                                                    </div>
                                                                    <div>
                                                                        <h6 className="mb-0 font-13" style={{
                                                                            fontWeight: 500,
                                                                            fontSize: '16px',
                                                                            lineHeight: '24px'
                                                                        }}>{item.karyawan.karyawan_nama}</h6>
                                                                        <p className="m-0 font-12">
                                                                            <span className="col-green font-weight-bold">
                                                                              {moment(item.created_at).format('lll')}
                                                                            </span>
                                                                        </p>
                                                                        <div style={{ marginTop: "4px" }}>
                                                                            {item.returned_date ? (
                                                                                <div
                                                                                    className="m-0"
                                                                                    style={{
                                                                                        border: '1px solid #000',
                                                                                        borderRadius: '25px',
                                                                                        width: '80px',
                                                                                        color: '#057CE4',
                                                                                        borderColor: '#057CE4',
                                                                                    }}
                                                                                >
                                                                                    <div style={{
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center"
                                                                                    }}>Selesai
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                <div
                                                                                    className="m-0"
                                                                                    style={{
                                                                                        border: '1px solid #000',
                                                                                        borderRadius: '25px',
                                                                                        width: '150px',
                                                                                        color: '#E6462E',
                                                                                        borderColor: '#E6462E',
                                                                                    }}>
                                                                                    <div style={{
                                                                                        paddingTop: '1px',
                                                                                        paddingBottom: '1px',
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center"
                                                                                    }}>Sedang Dipinjam</div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col xs={12} md={6} className="text-left" style={{
                                                                paddingTop: '28px',
                                                                paddingBottom: '16px',
                                                                paddingRight: '12px',
                                                                paddingLeft: '12px'
                                                            }}>
                                                                <div style={{
                                                                    display: "flex", alignItems: "center", gap: '3px',
                                                                }}>
                                                                    <h6>Tanggal Peminjaman : </h6>
                                                                    <h6>{moment(item.borrow_date).format('ll')}</h6>
                                                                </div>
                                                                {item.returned_date ? (
                                                                    <div style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: '3px'
                                                                    }}>
                                                                        <h6>Tanggal Pengembalian : </h6>
                                                                        <h6>{item.returned_date ? moment(item.borrow_date).format('ll') : ''}</h6>
                                                                    </div>
                                                                ) : null}
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}

                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter className="pengumuman-modal-footer">
                            {this.state.dataHistory.length !== 0 &&
                                <>
                                    <div className='col font-14' style={{
                                        padding: "auto",
                                        margin: "auto",
                                        fontWeight: 500,
                                        lineHeight: "24px"
                                    }}>Menampilkan {this.state.dataHistory.length === 0 || this.state.dataHistory.length === null ? "0" : this.state.dataHistory.length} dari {this.state.totalDataHistory} data
                                    </div>
                                    <div className='col'>
                                        <ReactPaginate
                                            previousLabel={<img src={ArrowLeft} alt=''/>}
                                            nextLabel={<img src={ArrowRight} alt=''/>}
                                            pageCount={this.state.pageCountHistory}
                                            forcePage={this.state.currentPageHistory}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={this.handlePageHistory}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link custom-page-link'}
                                            containerClassName={'pagination my-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link custom-page-link'}
                                            previousClassName={'page-item'}
                                            previousLinkClassName={'page-link custom-prev-next-link'}
                                            nextClassName={'page-item'}
                                            nextLinkClassName={'page-link custom-prev-next-link'}
                                            activeClassName={'active custom-active'}
                                        />
                                    </div>
                                </>
                            }
                        </ModalFooter>
                    </Modal>


                    <div className="container-fluid pt-4">
                        <div className='row'>
                            <div className='col-md-12' style={{
                                fontWeight: 400,
                                fontSize: "12px",
                                lineHeight: "16px",
                                color: "#5D6F80"
                            }}>Presensi Admin Panel
                            </div>
                        </div>
                        <div className='row mb-4'>
                            <div className='col-md-12' style={{
                                fontWeight: 700,
                                fontSize: "24px",
                                lineHeight: "36px",
                                color: "#143B5E"
                            }}>Daftar Inventaris
                            </div>
                        </div>
                        <div className="card">
                        <div className="card-header border-0 p-4">
                                <div className="row">
                                    <div className="col-md-6 pengumuman-col-filter">
                                        <div className="d-flex flex-row flex-nowrap">
                                            <div className="input-group form-search mr-1">
                                            <span className="input-group-text pengumuman-filter-nama-input-text">
                                                <img alt='' src={SearchIcon}/>
                                            </span>
                                                <input type="text" className="form-control pengumuman-filter-nama-input"
                                                       placeholder="Cari Inventaris ..." onKeyUp={(event) => {
                                                    if (event.which === 13) {
                                                        event.preventDefault()
                                                        this.setState({
                                                            page: 0,
                                                            paging: this.state.paging,
                                                            loading: true,
                                                            data: []
                                                        }, () => { this.loadData() })
                                                    }
                                                }} name="filter_nama" onChange={this.handleChange} value={this.state.filter_nama} />
                                            </div>
                                            <button className='pengumuman-button-refresh' onClick={this.resetFilter}>
                                                <img alt='' src={RefreshIcon}/>
                                            </button>
                                        </div>
                                    </div>
                                    <div className='col-md-6' style={{
                                        display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 10
                                    }}>
                                        {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("C") >= 0) && (
                                            <button className='pengumuman-add-button' onClick={() => this.setState({
                                                modalAdd: true
                                            })}><img alt='' src={PlusIcon}/> Tambah Inventaris
                                            </button>
                                        )}
                                        <Tooltip trigger={'click'} placement={'bottomLeft'} color={'#fff'} title={
                                            <div className="p-2">
                                                <a className="text-dark" onClick={()=> this.setState({
                                                    modalPinjam: true
                                                })}>Buat Peminjaman</a><br/>
                                                <a className="text-dark" onClick={() => this.setState({
                                                    modalImport: true,
                                                })}>Import</a><br/>
                                                <a className="text-dark" onClick={this.exportData}>Export</a>
                                            </div>
                                        }>
                                            <a><i
                                                style={{
                                                width: "46px",
                                                alignContent : "center",
                                                fontSize: 18,
                                                color: 'rgb(51 51 51)',
                                                height: "46px",
                                                paddingRight: "30px"
                                                }}
                                                className='btn border border-dark border-1 px-2'
                                            ><img src={MoreIcon}/></i></a>
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body daftar-pengumuman pt-3">
                                {!this.state.loading && this.state.data.length === 0 ?
                                    <Empty description="Data Kosong"
                                           image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg" />
                                    :
                                    (this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("R") >= 0) && (
                                        <Table className="table table-borderless mb-5">
                                            <Thead>
                                                <Tr>
                                                    <Th className="pengumuman-th-table text-center" style={{ maxWidth: "100px"  }}>#</Th>
                                                    <Th className="pengumuman-th-table" style={{ minWidth: "100px" }}>Nama Inventaris</Th>
                                                    <Th className="pengumuman-th-table" style={{ minWidth: "180px"}}>Deskripsi</Th>
                                                    <Th className="pengumuman-th-table" style={{ minWidth: "150px" }}>Peminjam saat ini</Th>
                                                    <Th className="pengumuman-th-table text-center"></Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {this.state.loading &&
                                                    <Tr>
                                                        <Td colSpan={5}>
                                                            <Spin size="large" tip="Loading..." style={{
                                                                width: '100%',
                                                                margin: 'auto',
                                                                marginBottom: '10px',
                                                                marginTop: '10px'
                                                            }} />
                                                        </Td>
                                                    </Tr>
                                                }
                                                {this.state.data.map((item, index) => {
                                                    no += 1
                                                    return (
                                                        <Tr>
                                                            <Td className="pengumuman-td-table text-center" style={{ maxWidth: "100px"  }}>{pageNumber(no, this.state.perPage, this.state.currentPage)}</Td>
                                                            <Td className="pengumuman-td-table" style={{ minWidth: "100px" }}>{item.inventaris_name}</Td>
                                                            <Td className="pengumuman-td-table" style={{ minWidth: "180px"}}>{item.inventaris_desc}</Td>
                                                            <Td className="pengumuman-td-table" style={{ minWidth: "150px" }}>{item.inventaris?.returned_date ? "Tersedia" : item.inventaris?.karyawan?.karyawan_nama || "Tersedia"}</Td>
                                                            <Td className="pengumuman-td-table text-center">
                                                                <Tooltip trigger={'click'} placement="bottom" color={'#fff'} zIndex={900} title={
                                                                    <div className="p-2">
                                                                        <a onClick={() => {
                                                                            this.setState({
                                                                                modalHistory: true,
                                                                                idHistory: item.inventaris_id
                                                                            }, () => this.loadHistory(item.inventaris_id))
                                                                        }} className="text-dark">
                                                                            Riwayat Peminjaman
                                                                        </a>
                                                                        <br/>
                                                                        {item.inventaris && !item.inventaris?.returned_date && (
                                                                            <>
                                                                                <a onClick={() => {
                                                                                    this.setState({
                                                                                        modalReturn: true,
                                                                                        idKembali: item.inventaris._inv_karyawan_id
                                                                                    })
                                                                                }} className="text-dark">
                                                                                    Selesaikan Peminjaman
                                                                                </a>
                                                                                <br/>
                                                                            </>
                                                                        )}
                                                                        {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("U") >= 0) && (
                                                                            <>
                                                                                <a onClick={() => this.setState({
                                                                                    idDetail: item.inventaris_id,
                                                                                }, () => this.loadDetail())}
                                                                                   className={'text-dark'}>Edit</a><br/>
                                                                            </>
                                                                        )}
                                                                        {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("D") >= 0) && (
                                                                            <>
                                                                                <a onClick={() => {
                                                                                    this.setState({
                                                                                        idDel: item.inventaris_id,
                                                                                    })
                                                                                    this.wantDelete()
                                                                                }} className={'text-danger'}>Hapus</a>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                }>
                                                                    <a><i
                                                                        className="fa fa-ellipsis-v" style={{
                                                                        width: 35,
                                                                        fontSize: 18,
                                                                        padding: 11,
                                                                        color: 'rgb(51 51 51)'
                                                                    }}
                                                                    ></i></a>
                                                                </Tooltip>
                                                            </Td>
                                                        </Tr>
                                                    )
                                                })}
                                            </Tbody>
                                        </Table>
                                    )
                                }
                                <Paging pageCount={this.state.pageCount} currentPage={this.state.currentPage} handlePageClick={this.handlePageClick} />
                            </div>
                        </div>
                    </div>

                    {/*Import Inventaris*/}
                    <Modal size="sm" zIndex={999} isOpen={this.state.modalImport} toggle={() => this.setState({
                        modalImport: false,
                    })} style={{ maxWidth: "500px"}}>
                        <ModalHeader toggle={() => {
                            this.setState({
                                modalImport: false,
                            })
                        }} className="pengumuman-modal-header">
                            <div className="pengumuman-modal-header-font">Import Inventaris</div>
                        </ModalHeader>
                        <ModalBody className="pengumuman-modal-body">
                            <div>
                                <div style={{ fontSize: '14px' }}>
                                    <a>Anda bisa mengunduh template yang sudah kami sediakan untuk mempermudah
                                        pengimportan.</a><br/>
                                    <a style={{color: "#057CE4"}} onClick={this.exportInventaris}>Unduh Template</a>
                                </div>
                                <div style={{
                                    position: 'relative',
                                    width: '100%',
                                    backgroundColor: '#F9F9F9',
                                    padding: 16,
                                    borderRadius: 6,
                                    marginTop: 8,
                                    border: "1px dashed #DDDDDD"
                                }}>
                                    <input type='file'
                                           accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                           onChange={(event) => {
                                               this.setState({
                                                   importFile: event.target.files[0],
                                               })
                                           }}
                                           /><br/>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter className="pengumuman-modal-footer">
                            {this.state.importLoading ?
                                <button className={'btn btn-primary'} style={{textTransform: "none", width: "100%"}}
                                        disabled={true}><i className="fa fa-refresh fa-spin"></i> Sedang mengupload data
                                </button>
                                :
                                <button
                                    className={this.state.importFile === null ? 'btn bg-secondary-custom' : 'btn btn-primary'}
                                    style={{textTransform: "none", width: "100%"}}
                                    disabled={this.state.importFile === null} onClick={this.importExcel}>Import
                                    Data</button>
                            }
                        </ModalFooter>
                    </Modal>

                </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withPageAccess(withTourGuide(ListInventaris), PERMISSIONS.INVENTARIS));